import React, {  useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./LoanCard.css";

// Utility: format date as DD-MM-YYYY
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;
  return date.toLocaleDateString("en-GB");
};

// Utility: format amount as Rs XXXX
const formatAmount = (amount) => {
  if (!amount || isNaN(amount)) return "Rs 0";
  return `Rs ${Number(amount).toLocaleString("en-IN")}`;
};

const LoanCard = () => {


  const [company, setCompany] = useState(null);
  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;


   const loan = {
    userName: "Rahul Kumar",
    customerId: "CUST-101",
    loanAccountNumber: "LN-00045",
    loanType: "Weekly Loan",
    loanAmount: 50000,
    loanPayable: 55000,
  };

   // ---------- STATIC EMI ----------
  const emis = [
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 1,
      dueDate: "2024-01-10",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: "2024-01-10",
    },
    {
      id: 2,
      dueDate: "2024-01-17",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
    {
      id: 3,
      dueDate: "2024-01-24",
      principalComponent: 2000,
      interestComponent: 200,
      emiAmount: 2200,
      paymentDate: null,
    },
  ];

  const emiAmountFromSchedule = emis[0].emiAmount;

  // company fetch
    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(
              /^images\//,
              ""
            )}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();

// ✅ Download Loan Card as PDF (Clean Version)
const downloadPageAsPDF = async () => {
  if (!loan) return;

  const doc = new jsPDF("p", "mm", "a4");
  const margin = 14;
  let y = 20;

  const pageWidth = doc.internal.pageSize.getWidth();
  const centerX = pageWidth / 2;

  // ---------- Load Logo (if exists) ----------
  const loadLogo = async () => {
    if (!company?.logoUrl) return null;

    try {
      const res = await fetch(company.logoUrl);
      const blob = await res.blob();
      return await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.error("Logo load failed:", err);
      return null;
    }
  };

  const logoImg = await loadLogo();

  // ---------- HEADER ----------
  if (logoImg) {
    doc.addImage(logoImg, "PNG", margin, y, 30, 30);
    doc.setDrawColor(200);
    doc.circle(margin + 15, y + 15, 16);
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(company?.name || "Company Name", centerX, y + 8, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  if (company?.cin)
    doc.text(`CIN: ${company.cin}`, centerX, y + 16, { align: "center" });

  if (company?.address)
    doc.text(`Regt. Office: ${company.address}`, centerX, y + 22, {
      align: "center",
    });

  doc.text(`Email: ${company?.email || "-"}`, centerX, y + 28, {
    align: "center",
  });

  doc.text(`Ph: ${company?.contact || "-"}`, centerX, y + 34, {
    align: "center",
  });

  // Divider
  y += 38;
  doc.setDrawColor(180);
  doc.line(margin, y, pageWidth - margin, y);

  // Title
  y += 10;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("LOAN CARD", centerX, y, { align: "center" });

  y += 10;

  // ---------- BODY ----------
  doc.setFontSize(13);
  doc.text("Customer & Loan Details", margin, y);

  y += 8;
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

const leftX = margin;
const rightX = 120;
const lineHeight = 6;

// Row 1
doc.text(`Customer Name: ${loan.userName}`, leftX, y);
doc.text(`Loan No: ${loan.loanAccountNumber}`, rightX, y);
y += lineHeight;

// Row 2
doc.text(`Loan Amount: ${formatAmount(loan.loanAmount)}`, leftX, y);
doc.text(`Branch: ${loan.branch || "NA"}`, rightX, y);
y += lineHeight;

// Row 3
doc.text(`Number of EMI: ${emis.length}`, leftX, y);
doc.text(`Plan: ${loan.loanType || loan.planName || "NA"}`, rightX, y);
y += lineHeight;

// Row 4
doc.text(`EMI Amount: ${formatAmount(emiAmountFromSchedule)}`, leftX, y);
doc.text(
  `Exit Amount: ${formatAmount(loan.exitAmount || loan.loanPayable)}`,
  rightX,
  y
);
y += lineHeight;


  // ---------- EMI TABLE ----------
  autoTable(doc, {
    startY: y,
    head: [[
      "EMI No",
      "Due Date",
      "Principal",
      "Interest",
      "EMI Amount",
      "Paid Date",
      "Staff Sign",
      "Customer Sign",
    ]],
    body: emis.map((emi, i) => [
      i + 1,
      formatDate(emi.dueDate),
      formatAmount(emi.principalComponent),
      formatAmount(emi.interestComponent),
      formatAmount(emi.emiAmount),
      emi.paymentDate ? formatDate(emi.paymentDate) : "-",
      "",
      "",
    ]),
    theme: "grid",
    styles: { fontSize: 9 },
    headStyles: { fillColor: [16, 144, 191], textColor: 255 },
    margin: { left: margin, right: margin },
  });

  // ---------- SAVE ----------
  doc.save(`LoanCard_${loan.loanAccountNumber || loan.loanNumber}.pdf`);
};

  return (
    <div className="AdminLoanCardPage-container">
      {/* HEADER */}
      <header className="AdminLoanCardPage-header">
        <div className="LoanCard-logo-container">
          {company?.logoUrl && (
            <img src={company.logoUrl} alt="Logo" className="LoanCard-logo" />
          )}
        </div>

        <div className="LoanCard-company-info-right">
          <h2 className="company-name">{company?.name || "Company Name"}</h2>
          {company?.cin && <p><strong>CIN:</strong> {company.cin}</p>}
          {company?.address && <p><strong>Regt. Office:</strong>{company.address}</p>}
          {company?.email && <p><strong>Email:</strong> {company.email}</p>}
          {company?.contact && <p><strong>Contact:</strong> {company.contact}</p>}
        </div>

        <div  style={{ opacity: 0 }} className="LoanCard-logo-container">
          {company?.logoUrl && (
            <img src={company.logoUrl} alt="Logo" className="LoanCard-logo" />
          )}
        </div>
        
      </header>

      <div className="LoanCard-title-center">
        <h3>Loan Card</h3>
      </div>

      {/* Loan & Customer Details */}
      <section className="AdminLoanCardPage-details">
        <div><strong>Customer Name:</strong> {loan.userName}</div>
        <div><strong>customer Id:</strong> {loan.customerId || "NA"}</div>

        {/* <div><strong>Guardian Name:</strong> {loan.guardianName || "NA"}</div> */}
        <div><strong>Loan Number:</strong> {loan.loanAccountNumber}</div>
        {/* <div><strong>Branch:</strong> {loan.branchName || "NA"}</div> */}
        {/* <div><strong>Contact No:</strong> {loan.contactNo || "-"}</div> */}
        <div><strong>Plan Name:</strong> {loan.loanType || loan.planName || "NA"}</div>
        <div><strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}</div>
        <div><strong>EMI Amount:</strong> {formatAmount(emiAmountFromSchedule)}</div>
        <div><strong>Number of EMI:</strong> {emis.length}</div>
        <div><strong>Exit Amount:</strong> {formatAmount(loan.loanPayable)}</div>
      </section>

      {/* EMI Schedule */}
      <section className="AdminLoanCardPage-table">
        <h2 className="loan-card-page-header">EMI Schedule</h2>
        <table>
          <thead>
            <tr>
              <th>EMI No</th>
              <th>Due Date</th>
              <th>Principal</th>
              <th>Interest</th>
              <th>EMI Amount</th>
              <th>Payment Date</th>
              <th>Staff Sign</th>
              <th>Customer Sign</th>
            </tr>
          </thead>
          <tbody>
            {emis.map((emi, index) => (
              <tr key={emi.id}>
                <td>{index + 1}</td>
                <td>{formatDate(emi.dueDate)}</td>
                <td>{formatAmount(emi.principalComponent)}</td>
                <td>{formatAmount(emi.interestComponent)}</td>
                <td>{formatAmount(emi.emiAmount)}</td>
                <td>{emi.paymentDate ? formatDate(emi.paymentDate) : "-"}</td>
                <td></td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* Download Button */}
      <div className="AdminLoanCardPage-btn-wrapper">
        <button
          className="AdminLoanCardPage-download-btn"
          onClick={downloadPageAsPDF}
        >
          📥 Download PDF
        </button>
      </div>
    </div>
  );
};

export default LoanCard;
